import Localization from '@/components/Localization';
import ThemeLayout from '@/components/Template';
import Loader from '@/components/Template/Loader';
import { ThemeContextConsumer } from '@/contexts/ThemeContext';
import React from 'react';
import Loadable from 'react-loadable';
import { Route, RouteComponentProps } from 'react-router-dom';
import Switch from 'react-router-transition-switch';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { AnyType } from './type';

type Props = RouteComponentProps;

const loadable = (loader) =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />
  });

const routes = [
  {
    path: '/',
    component: loadable(() => import('./pages/Initialize')),
    exact: true
  },
  {
    path: '/smartcardlogin',
    component: loadable(() => import('./pages/SmartCardLogin')),
    exact: true
  },
  {
    path: '/accountinfo',
    component: loadable(() => import('./pages/AccountInfo')),
    exact: true
  },
  {
    path: '/accountcreate',
    component: loadable(() => import('./pages/AccountCreate')),
    exact: true
  },
  {
    path: '/signresult',
    component: loadable(() => import('./pages/SignHRXmlResult')),
    exact: true
  },
  {
    path: '/migration',
    component: loadable(() => import('./pages/Migration')),
    exact: true
  }
];

const Routes = () => {
  return (
    <ThemeContextConsumer>
      {([{ locale, routerAnimation }]) => (
        <Localization locale={locale}>
          <ThemeLayout>
            <Switch
              render={(props: AnyType) => {
                const {
                  children,
                  location: { pathname }
                } = props;
                return (
                  <SwitchTransition>
                    <CSSTransition key={pathname} classNames={routerAnimation} timeout={routerAnimation === 'none' ? 0 : 300}>
                      {children}
                    </CSSTransition>
                  </SwitchTransition>
                );
              }}
            >
              {routes.map(({ path, component: component, exact }) => (
                <Route path={path} key={path} exact={exact} component={component} />
              ))}
            </Switch>
          </ThemeLayout>
        </Localization>
      )}
    </ThemeContextConsumer>
  );
};

export default Routes;
